export default {
    token: null,
    pageInfo: null,
    dealsPageInfo: null,
    deals: null,
    tokenRequests: null,
    dealMembers: null,
    tokenTransactions: null,
    page: 0,
    pages: 0,
    totalTransactions: null,
    dealInvestors: null,
    members: null,
    dealroomMembers: null,
    dealroomWaitlist: null,
    allDealRoomMembers: [],

    // state from investor-base
    // Primary-market bids. Distinct from orderBook, which is the secondary market —
    // a commitment settles at allotment, not on match.
    commitments: null,
    // Aggregate demand for an offering. Shown only once bidding has stopped;
    // see hasResolvedBook() in utils/offering.js.
    offeringBook: null,
    exchangeListings: [],
    exchangeListingsLoaded: false,
    exchangeRaising: [],
    marketActivity: [],
    marketActivityLoading: false,
    // /transaction/market-stats for the active currency; null until it loads.
    exchangeStats: null,
    portfolioPerformance: [],
    portfolioPerformanceLoading: false,
    userTokens: null,
    unlimitedUserTokens: null,
    userDealRooms: [],
    privateTokens: null,
    raisingTokens: [],
    raisingPages: 0,
    raisingPage: 0,
    orderBook: [],
    orderBookPages: 0,
    orderBookPage: 0,
    publicTokens: [],
    tokenInfo: {},
    assetInfo: {},
    raisedTokens: [],
    raisedPages: 0,
    raisedPage: 0,
    investorTokenPages: 0,
    investorTokenPage: 0,
    tokenBalance: 0,
    tokenPayoutDetails: {},
    dealRoomInfo: null,
    tokenUpdates: [],
    buyOrderBook: [],
    sellOrderBook: [],
    tokenUpdatePage: 0,
    tokenUpdatePages: 0,
    subscriptionStatus: null,
    subscriptionPlans: null,
    orgInfo: null,
    whyWeListed: {},
    certificateInfo: null,
    badgeInfo: null,
    membershipStatus: null,
};